/* eslint-disable no-unused-expressions */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-cycle */
/* eslint-disable no-plusplus */
import React, { useEffect } from 'react';
import style from './profilePage.module.scss';
import '../../constants/_global.scss';
import Profile from '../../pageParts/profile/profile';
import { ProfilePageInterface } from './profilePageTypes';
import Line from '../../UI/line/line';
import Grid from '../../pageParts/grid/grid';
import { useDispatch, useSelector } from '../../index';
import {
  getOwnFavoriteListings,
  getOwnListings,
  setFavoritePageNumber,
  setPageNumber,
} from '../../service/ListingData';
import Pagination from '../../pageParts/pagination/pagination';

const ProfilePage: React.FC<ProfilePageInterface> = ({
  onEdit,
  onProfileEdit,
  listingClick,
}) => {
  const userData = useSelector((state) => state.userData.user);
  const ownerIdCheck = (id: number) => userData.id === id;
  const pageNumber = useSelector((state) => state.listingData.pageNumber);
  const favoritePage = useSelector(
    (state) => state.listingData.pageFavoritesNumber
  );
  const dispatch = useDispatch();
  const maxFavoritePage = useSelector(
    (state) => state.listingData.totalFavoritePages
  );
  const userListningData =
    useSelector((state) => state.listingData.ownListings) || [];
  const favoriteData =
    useSelector((state) => state.listingData.ownFavoriteListings) || [];

  useEffect(() => {
    dispatch(setPageNumber(1));
    dispatch(setFavoritePageNumber(1));
    dispatch(getOwnListings(1));
    dispatch(getOwnFavoriteListings(1));
  }, []);

  const isFavoriteOwn = (id: number) => {
    console.log(id);
    return true;
  };

  const favoritePageMove = (n: number) => {
    dispatch(getOwnFavoriteListings(n));
    dispatch(setFavoritePageNumber(n));
  };

  const ownListingsPageMove = (n: number) => {
    dispatch(getOwnListings(n));
    dispatch(setPageNumber(n));
  };

  return (
    <div className={style.shell}>
      <Profile data={userData} onEdit={onProfileEdit} />
      <Line width={1320} height={1} />
      <div className={style.listningBlock}>
        <h1 className="h1">Избранные объявления</h1>
        {favoriteData.length > 0 ? (
          <div className={style.gridAndPaginaton}>
            <Grid
              listings={favoriteData}
              onEdit={onEdit}
              onClick={listingClick}
              onFavorite={() => console.log('favorite')}
              isOwner={ownerIdCheck}
              alreadyFavorite={isFavoriteOwn}
              favoriteVisable={false}
            />
            <Pagination
              clicker={favoritePageMove}
              maxPage={maxFavoritePage}
              pageNumber={favoritePage}
            />
          </div>
        ) : (
          <h2 className="h2">Здесь пока пусто...</h2>
        )}
      </div>
      <Line width={1320} height={1} />
      <div className={style.listningBlock}>
        <h1 className="h1">Мои объявления</h1>
        {userListningData.length > 0 ? (
          <div className={style.gridAndPaginaton}>
            <Grid
              listings={userListningData}
              onEdit={onEdit}
              onClick={listingClick}
              onFavorite={() => console.log('favorite')}
              isOwner={ownerIdCheck}
              alreadyFavorite={isFavoriteOwn}
            />
            <Pagination clicker={ownListingsPageMove} pageNumber={pageNumber} />
          </div>
        ) : (
          <h2 className="h2">Здесь пока пусто...</h2>
        )}
      </div>
      <Line width={1320} height={1} />
    </div>
  );
};

export default ProfilePage;
